import { ILmpBlock } from "@sky-it-livedata/livedata-sports-design-system";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { isValidLmpHeroQuery } from "./typeguards";
import { CreateLmpHeroInputSchema, LmpHero } from "appsync";
import { LmpHeroQuery } from "../types";


export interface IMatchHero {
  readonly match: LmpHero;
  readonly hasVideo?: boolean;
  readonly isSlim?: boolean;
  readonly hasFollowMatch?: boolean | null;
}

type ITransformedMatch = ILmpBlock['match'] & {
  customCompetitionName?: string;
};

const transformer = (obj: LmpHeroQuery): ILmpBlock => {

  if (isValidLmpHeroQuery(obj)) {
    CreateLmpHeroInputSchema().parse(obj.data?.getLmpHero);
    const { competition, hasFollowMatch, matchId, createdAt, updatedAt, ...match } = obj.data.getLmpHero;

    const transformedMatch = ({
      ...match,
      customCompetitionName: competition?.name ?? undefined,
    } as unknown) as ITransformedMatch;
    
    const { negativeLogoUrl:negativeLogoUrlHome, ...home } = match.home!;
    const { negativeLogoUrl:negativeLogoUrlAway, ...away } = match.away!;

    const payload: ILmpBlock = {
      hasVideo: false,
      isSlim: false,
      match: {
        ...transformedMatch,
        matchId,
        away: {
          ...away,
          logoUrl: negativeLogoUrlAway || away.logoUrl,
        } as ITransformedMatch['away'],
        home: {
          ...home,
          logoUrl: negativeLogoUrlHome || home.logoUrl,
        } as ITransformedMatch['home'],
      },
    };

    return payload;
  } else {
    throw new WidgetError<ErrorName>({
      name: "NO_VALID_DATA",
      message: "Invalid transformer input, Error in LmpHeroQuery object",
      data: obj,
    });
  }
};

export default transformer;
